import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const ResetFormDialog = ({ visible, onHide, onConfirmReset, formId }) => {
  const dialogFooter = (
    <>
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        className="p-button-danger"
        onClick={() => onConfirmReset(formId)}
      />
    </>
  );

  return (
    <Dialog
      header="Reset Form"
      visible={visible}
      style={{ width: "450px" }}
      modal
      footer={dialogFooter}
      onHide={onHide}
    >
      <div className="confirmation-content">
        <i
          className="pi pi-exclamation-triangle"
          style={{ fontSize: "2rem", color: "#FFA500", marginRight: "10px" }}
        />
        <span>
          Are you sure you want to reset this form? This will delete all
          collected data for this form and cannot be undone.
        </span>
      </div>
    </Dialog>
  );
};

export default ResetFormDialog;
